import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import config from '../../config'
import './style'

class Result extends Component {
	static countScore(arr) {
		const acc = (common, current) => common + current
		return ((arr.reduce(acc) / arr.length) * 100).toFixed(0)
	}

	static getTypes(currentType) {
		const { demo } = config.routes
		const res = { current: {}, additional: [] }

		Object.keys(demo).forEach((key) => {
			if (demo[key].toolType === currentType) {
				res.current = demo[key]
			} else {
				res.additional.push(demo[key])
			}
		})

		return res
	}

	render() {
		const { app, liveResults, toolType } = this.props
		const { isMobile } = app
		const score = Result.countScore(liveResults || 0)
		const typesArr = Result.getTypes(toolType)

		return (
			<React.Fragment>
				<div className="row tasks-result">
					<div className="col-1 sm-hidden" />
					<div className="score-page col-4 col-sm-4 col-xs-2">
						<p className="text-5-type-1 caption-currentTask">
							{typesArr.current.name} result
						</p>

						<h1
							className={`${isMobile ? 'text-1-type-2' : 'heading-2-type-1'} font-medium`}
						>
							Your score is {score}%
						</h1>

						<div className="description font-regular text-3-type-3">
							<React.Fragment>
								Share your feedback at <a href="mailto: hello@handl.ai">hello@handl.ai</a>,
								<a className="nowrap" href={config.social.twitter}>&nbsp;
									<span className="icon icon-twitter" />
									<span className="link-text">&nbsp;follow</span>
								</a> us on Twitter, <br />
								<a href={config.social.facebook}>&nbsp;
									<span className="icon icon-facebook" />
									<span className="link-text">&nbsp;like</span>
								</a> us on Facebook.
							</React.Fragment>
						</div>

						<div className="buttons">
							<a
								className="btn"
								target="_blank"
								href={config.outer.signup}
							>
								Signup for Alpha
							</a>

							<a
								className="btn btn-border-blue"
								href={typesArr.current.path}
							>
								Start over
							</a>
						</div>

						<div className="result-bottom">
							{
								typesArr.additional.map(item => (
									<Link
										className="bttn bttn-type__default bttn-size__middle"
										key={item.name}
										to={item.path}
									>
										{item.name}
									</Link>
								))
							}
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

Result.propTypes = {
	app: PropTypes.object.isRequired,
	toolType: PropTypes.string.isRequired,
	liveResults: PropTypes.array.isRequired,
}

export default Result
